import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { VariantType } from '../../../../types';
import type { NotificationItem } from '../../types';
import styles from './NewsLetterList.module.scss';

export interface NewsLetterListProps {
  items: Array<NotificationItem>;
  values: number[];
  InputSwitchComponent: React.ComponentType<{
    name: string;
    inputValue: number;
    onChange: () => void;
    checked: boolean;
  }>;
  onSubmit: (permission: number) => Promise<void>;
  variant?: VariantType;
}

function NewsLetterList({ items, values, InputSwitchComponent, onSubmit }: NewsLetterListProps) {
  const handleToggle = (value: number, currentCheckList: number[]) => {
    let changed: number[];
    if (currentCheckList.includes(value)) {
      changed = currentCheckList.filter((check) => check !== value);
    } else {
      changed = [...currentCheckList, value];
    }
    const permission = changed.reduce((a, b) => Number(a) + Number(b), 0);
    onSubmit(permission);
  };

  return (
    <ul className={styles.notificationList}>
      {items.map((v) => (
        <li key={v.value}>
          <div className={styles.itemBlock}>
            <div>
              <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>{v.title}</p>
              <p className={utilsStyles.textXSmall}>{v.description}</p>
            </div>
            <div>
              <InputSwitchComponent
                name='notification'
                inputValue={v.value}
                onChange={() => {
                  handleToggle(v.value, values);
                }}
                checked={values.includes(v.value)}
              />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default NewsLetterList;
